import { FrmSelectFromObjects } from "components/formFields/FrmSelectFromObjects";

import { useTaxCodes, TAX_CODE_TYPE_SALES } from "hooks/useTaxCodes";

export function FrmSalesTaxCode(props) {
  const { value, name, onValueChange } = props;

  const taxCodes = useTaxCodes(TAX_CODE_TYPE_SALES);

  return (
    <FrmSelectFromObjects
      name={name}
      options={taxCodes?.length ? taxCodes : []}
      onValueChange={onValueChange}
      value={value}
    />
  );
}
